import { LK_TABLE_CELL_TYPE } from '@components/lk/lk-table/data/lk.table.data'

export const LEADS_TABLE_CONFIG = [
  {
    width: '25%',
    label: 'Название',
    key: 'description',
    templateName: 'description',
    type: LK_TABLE_CELL_TYPE.TEMPLATE,
  },
  {
    width: '20%',
    label: 'Дата',
    key: 'date',
    templateName: '',
    type: LK_TABLE_CELL_TYPE.DATE,
  },
  {
    width: '20%',
    label: 'Вендор',
    key: 'vendor',
    templateName: 'vendor',
    type: LK_TABLE_CELL_TYPE.TEMPLATE,
  },
  {
    width: '35%',
    label: 'Ответственный',
    key: 'user',
    templateName: 'user',
    type: LK_TABLE_CELL_TYPE.TEMPLATE,
  },
]



// WEBPACK FOOTER //
// ./src/templates/pages/lk/leads/config/leads.table.config.js